import { Typography } from "@material-ui/core";
import { useOktaAuth } from "@okta/okta-react";
import { LynxButton } from "components/LynxButton/LynxButton";
import { LynxCheckBox } from "components/LynxCheckBox/LynxCheckBox";
import { LynxInput } from "components/LynxInput/LynxInput";
import { LynxLink } from "components/LynxLink/LynxLink";
import React, { ChangeEvent, useState } from "react";
import { signInFormStyles } from "./SignInFormStyles";

// TODO: refactor using Formik or something similar
// TODO: add validation and error displaying
// TODO: implement forgot password
export function SignInForm() {
    const classes = signInFormStyles();

    const { oktaAuth } = useOktaAuth();

    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(
        !!localStorage.getItem("email")
    );
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleEmailChange = ({
        target: { value },
    }: ChangeEvent<HTMLInputElement>) => {
        setEmail(value);
    };

    const handlePasswordChange = ({
        target: { value },
    }: ChangeEvent<HTMLInputElement>) => {
        setPassword(value);
    };

    const handleRememberMeChange = (
        e: ChangeEvent<HTMLInputElement>,
        checked: boolean
    ) => {
        setRememberMe(checked);
    };

    const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
        e.preventDefault();

        if (loading) {
            return;
        }

        setLoading(true);
        setError("");

        if (rememberMe) {
            localStorage.setItem("email", email);
        } else {
            localStorage.removeItem("email");
        }

        try {
            const response = await oktaAuth.signInWithCredentials({
                username: email,
                password,
            });
            const sessionToken = response.sessionToken;
            // sessionToken is a one-use token, so make sure this is only called once
            // @ts-ignore
            await oktaAuth.signInWithRedirect({ sessionToken });
        } catch (error) {
            console.log("Found an error", error);
            setError("Incorrect email or password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className={classes.form} onSubmit={onSubmit}>
            {error && (
                <Typography variant="body1" className={classes.errorLabel}>
                    {error}
                </Typography>
            )}
            <LynxInput
                size="large"
                name="email"
                value={email}
                label="Email"
                onChange={handleEmailChange}
                placeholder="contact@carrier.com"
                formControlClassName={classes.firstInputMargin}
            />
            <LynxInput
                size="large"
                name="password"
                value={password}
                label="Password"
                onChange={handlePasswordChange}
                type="password"
                formControlClassName={classes.secondInputMargin}
            />
            <LynxLink href="#" containerClassName={classes.forgotPassword}>
                Forgot your password?
            </LynxLink>
            <LynxButton
                className={classes.signInButton}
                size="large"
                responsive={false}
                type="submit"
                loading={loading}
            >
                Sign In
            </LynxButton>
            <LynxCheckBox
                checked={rememberMe}
                onChange={handleRememberMeChange}
                labelClassName={classes.rememberBe}
                label="Remember me"
                size="small"
            />
        </form>
    );
}
